import { FC, PropsWithChildren } from 'react';
import { Accordion, AccordionDetails, AccordionProps, AccordionSummary, Card, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface CardAccordionProps extends AccordionProps {
  title: string,
  titleAdditionalIcon?: React.ReactNode
}

const CardAccordion: FC<PropsWithChildren<CardAccordionProps>> = ({ title, titleAdditionalIcon, children, ...props }) => {

  return (
    <Card
      elevation={2}
      sx={{ marginBottom: '15px' }}>
      <Stack
        sx={(theme) => ({
          borderLeft: '6px solid',
          borderColor: theme.colors.primary
        })}>
        <Accordion
          elevation={2}
          {...props}
          sx={{
            borderRadius: 0
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id={`${props.key ?? 1}`}
            sx={{
              '&.Mui-expanded': {
                minHeight: 0
              }
            }}
          >
            <Stack direction="row" width="98%" justifyContent="space-between" alignItems="center">
              <Typography sx={{
                lineHeight: '40px',
                letterSpacing: '0.1em',
                textTransform: 'uppercase'
              }}>
                {title}
              </Typography>
              {titleAdditionalIcon}
            </Stack>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: '0px 16px 8px 16px' }}>
            {children}
          </AccordionDetails>
        </Accordion>
      </Stack>
    </Card>
  );
}

export default CardAccordion;
